import React from "react";
import styled from "styled-components";

interface CloseIconProps {
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  color?: string;
  width?: number;
  height?: number;
}

const SvgContainer = styled.div<{ width: number; height: number }>`
  cursor: pointer;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  display: flex;
  align-items: center;
`;

const Svg = styled.svg`
  width: 100%;
  height: 100%;
  fill: none;
`;

const Path = styled.path<{ color: string }>`
  stroke: ${({ color }) => color};
  stroke-width: 4;
`;

const CloseIcon: React.FC<CloseIconProps> = ({ onClick, color = "#FEC307", width = 27, height = 27 }) => {
  return (
    <SvgContainer onClick={onClick} width={width} height={height}>
      <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27">
        <Path d="M5.41422 4.58582L22.4142 21.5858" color={color} />
        <Path d="M22.4142 4.58582L5.41422 21.5858" color={color} />
      </Svg>
    </SvgContainer>
  );
};

export default CloseIcon;
